export default "__VITE_ASSET__BeV0vK9b__"